import { useNavigate, Link } from "react-router-dom";
import api from "../../api/axios";
import { reportClientError } from "../../api/errorReporter";
import { useState } from "react";
import "../../css/login/join.css"; // CSS 파일 import

function Join() {

    const navigate = useNavigate();

    const [loginId, setLoginId] = useState("");
    const [loginPw, setLoginPw] = useState("");
    const [loginPw2, setLoginPw2] = useState("");
    const [userName, setUserName] = useState("");
    const [email, setEmail] = useState("");
    const [joinCode, setJoinCode] = useState("");

    const join = () => {

        api.post("/user/join", {

            loginId,
            loginPw,
            loginPw2,
            userName,
            email,
            joinCode

        }).then((res) => {

            alert(res.data.message);

            if (res.data.success) {

                navigate("/login");

            }

        }).catch((err) => {

            console.error(err);
            reportClientError(err, "API_ERROR", { endpoint: "/join" });

        });

    };

    return (
        <div className="join-container">
            <div className="join-card">
                <div className="join-header">
                    <h2>GooseDuck Trading</h2>
                    <div className="join-subtitle">회원가입</div>
                </div>

                <input className="join-input" placeholder="아이디" value={loginId} onChange={(e) => setLoginId(e.target.value)} />
                <input className="join-input" type="password" placeholder="비밀번호" value={loginPw} onChange={(e) => setLoginPw(e.target.value)} />
                <input className="join-input" type="password" placeholder="비밀번호 확인" value={loginPw2} onChange={(e) => setLoginPw2(e.target.value)} />
                <input className="join-input" placeholder="이름" value={userName} onChange={(e) => setUserName(e.target.value)} />
                <input className="join-input" placeholder="이메일" value={email} onChange={(e) => setEmail(e.target.value)} />
                <input className="join-input" placeholder="인증코드" value={joinCode} onChange={(e) => setJoinCode(e.target.value)} />

                <button className="join-button" onClick={join}>회원가입</button>

                <div className="join-footer">
                    <Link to="/login" className="join-link">로그인으로 돌아가기</Link>
                </div>
            </div>
        </div>
    );

}

export default Join;
